/* The Milk Artist — brand behavior v13. Fail-open: if anything here breaks, the store renders normally. */
(() => {
  const normalize = (value) => (value || '').trim().toLowerCase();
  const prefersReducedMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inDesignMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---- Section classification (by visible heading, matches homepage content) ---- */
  const enhanceSections = () => {
    document.querySelectorAll('section, .shopify-section').forEach((section) => {
      const heading = section.querySelector('h1, h2, .title');
      const text = normalize(heading && heading.textContent);
      if (!text) return;

      if (text.includes('the milk gallery')) {
        section.classList.add('tma-milk-gallery');
        if (!document.getElementById('milk-gallery')) {
          const anchor = document.createElement('span');
          anchor.id = 'milk-gallery';
          anchor.className = 'tma-anchor';
          anchor.setAttribute('aria-hidden', 'true');
          section.prepend(anchor);
        }
      }
      if (text.includes('nail the shot') || text.includes('coffee made at home')) {
        section.classList.add('tma-creator-video');
      }
      if (text.includes('welcome to the milk artist')) {
        section.classList.add('tma-brand-welcome');
      }
    });
  };

  /* ---- Header shadow once scrolled ---- */
  const setupHeader = () => {
    const wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    const update = () => wrapper.classList.toggle('tma-scrolled', window.scrollY > 6);
    update();
    window.addEventListener('scroll', update, { passive: true });
  };

  /* ---- Scroll reveal. Skipped entirely for reduced motion / theme editor. ---- */
  const setupReveals = () => {
    if (prefersReducedMotion || inDesignMode || !('IntersectionObserver' in window)) return;

    const sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (sections.length < 2) return;

    const targets = [];
    sections.forEach((section, index) => {
      if (index === 0) return;                       // hero paints instantly
      if (section.querySelector('.section-divider')) return; // wave dividers must butt-join
      section.classList.add('tma-reveal');
      targets.push(section);
    });
    if (!targets.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('tma-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    targets.forEach((t) => io.observe(t));

    /* Failsafe: never leave content hidden, no matter what. */
    window.setTimeout(() => {
      targets.forEach((t) => t.classList.add('tma-in'));
    }, 4000);
  };

  const init = () => {
    try { enhanceSections(); } catch (e) { /* noop */ }
    try { setupHeader(); } catch (e) { /* noop */ }
    try { setupReveals(); } catch (e) {
      document.querySelectorAll('.tma-reveal').forEach((t) => t.classList.add('tma-in'));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    try { enhanceSections(); } catch (e) { /* noop */ }
  });
})();
